import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServicesRoutingModule } from './services-routing.module';
import { MainservicelistComponent } from './mainservices/mainservicelist/mainservicelist.component';
import { MainserviceformComponent } from './mainservices/mainserviceform/mainserviceform.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatspinnerComponent } from './matspinner/matspinner.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { HttpClientModule } from '@angular/common/http';
import { SubservicelistComponent } from './subservices/subservicelist/subservicelist.component';
import { SubserviceformComponent } from './subservices/subserviceform/subserviceform.component';
import { NgxSummernoteModule } from 'ngx-summernote';
import { SubservicesfieldsformComponent } from './subservicesfields/subservicesfieldsform/subservicesfieldsform.component';
import { SubservicesfieldsdropdownitemsformComponent } from './subservicesfieldsdropdownitems/subservicesfieldsdropdownitemsform/subservicesfieldsdropdownitemsform.component';
import { ServicesamountsfeesformComponent } from './servicesamountsfees/servicesamountsfeesform/servicesamountsfeesform.component';
import { ServiceordersComponent } from './servicesorders/serviceorders/serviceorders.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ServicesbymandoobComponent } from './reports/servicesbymandoob/servicesbymandoob.component';


@NgModule({
  declarations: [
    MainservicelistComponent,
    MainserviceformComponent,
    MatspinnerComponent,
    SubservicelistComponent,
    SubserviceformComponent,
    SubservicesfieldsformComponent,
    SubservicesfieldsdropdownitemsformComponent,
    ServicesamountsfeesformComponent,
    ServiceordersComponent,
    ServicesbymandoobComponent],
  imports: [
    CommonModule,
    ServicesRoutingModule,
    FormsModule,
    HttpClientModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatDialogModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatSnackBarModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatRippleModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    TranslateModule,
    NgxSummernoteModule,
    ClipboardModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ServicesModule { }
